import { Text, View } from 'wiloke-react-core';
import Section from '../../components/Section';

const NotFoundPage = () => {
  return (
    <View>
      <View container>
        <Section>
          <Text tagName="h1">404</Text>
        </Section>
      </View>
    </View>
  );
};

export default NotFoundPage;
